import React, {useState, useEffect} from 'react';
import ReactLoading from 'react-loading';
import {auth ,db, getValUserCredentials, promotetomod, demotetouser} from '../utils/firebase-config';
import {Table, Button, Popover, OverlayTrigger} from 'react-bootstrap';
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import {query,getDocs,collection,where,onSnapshot} from "firebase/firestore";
import '../css/users.css';
function UserPage() {
    const [Loading, setLoading] = useState(false) 
    const [users, setUsers] = useState([]);
    const [user, loading, error] = useAuthState(auth);
    const navigate = useNavigate();
    const [usercred, setUserCred] = useState("td");
    const [name, setName] = useState("");

    getValUserCredentials(user?.uid).then((rs) => {
        setUserCred(rs);
    });

    const fetchUserName = async () => {
        try {
          const q = query(collection(db, "users"), where("uid", "==", user?.uid));
          console.log(user?.uid);
          const doc = await getDocs(q);
          const data = doc.docs[0].data();
          setName(data.valorant_name);
        } catch (err) {
          console.error(err);
          setName("You magnificent creature");
        }
    };

    const checkusercreds = async() => {
        if (usercred == "moderator") {
          console.log("welcome mod");
        }if(usercred == "user") {
            navigate("/");
        }if(usercred == "error") {
            setLoading(true);
        }else{
            console.log("TBD");
            
        }
    }
    //query users before mounting
    const getUsers = async () => {
        setLoading(true);
        const q = query(collection(db, "users"), where("current_tier", "!=", null));
        onSnapshot(q, (snapshot) =>{
            const all_docs = snapshot.docs.map(doc => doc.data());
            console.log(all_docs);
            setUsers(all_docs);
        });
        setLoading(false);
    }

    const promoteuserpopup = (
        <Popover id="popover-anchor">
            <Popover.Header as="h3">Promote</Popover.Header>
            <Popover.Body>
            Promote user to mod.
            </Popover.Body>
        </Popover>
    );

    const demoteuserpopup = (
        <Popover id="popover-replacedown">
            <Popover.Header as="h3">Demote</Popover.Header>
            <Popover.Body>
            Demote mod to user.
            </Popover.Body>
        </Popover>
    );

    function PromoteButton(props) {
        const user = props.user;
        const namo = props.name;
        const rs = user.type_user
        if(rs == "user"){
            return (
                <OverlayTrigger trigger={['hover', 'focus']} placement="left" overlay={promoteuserpopup}>
                    <Button variant='success'   onClick={() => promotetomod(user.valorant_name)}>Promote</Button>
                </OverlayTrigger>
            )
        }if(rs == "moderator"){
            if(user.valorant_name == "Cetinator"){
                return(<a href="https://www.biblegateway.com/passage/?search=Psalm%2040%3A5&version=NIV" target="_blank" >Psalm 40:5</a>)  
            }
            if(user.valorant_name == "ImpulsiveEmpathy"){
                return(<a href="https://www.biblegateway.com/passage/?search=Psalm+146%3A10&version=NIV" target="_blank" >Psalm 146:10</a>)  
            }
            if(user.valorant_name == namo){
                return(<p>can't demote yourself g</p>)  
            }else{
                return (
                    <OverlayTrigger trigger={['hover', 'focus']} placement="left" overlay={demoteuserpopup}>
                        <Button variant='warning'   onClick={() => demotetouser(user.valorant_name)}>Demote</Button>
                    </OverlayTrigger>
                )
            }
        }else{
            return(<></>)
        }
    }
    
    useEffect(() => {
        checkusercreds();
        getUsers();
        fetchUserName();
    }, [user, loading, usercred])

    if(Loading){
        return(
        <div className="busy">
            <h4>Getting users data</h4>
            <ReactLoading className="loadingbar" type='bars' color='grey' height={'20vw'} width={'20vw'} />
        </div>
        )
    }else{
        return (
            <div>
                <hr />
                <Table striped bordered hover  size="sm">
                    <thead>
                        <tr>
                            <th>Moderator Actions</th>
                            <th>Valorant id</th>
                            <th className="rankbadge">current rank</th>
                            <th className="rankbadge">max rank </th>
                            <th>time played</th>
                        </tr>
                    </thead>
                    <tbody>
                    {users.map((user) => {
                        return  <tr>
                                    <td><PromoteButton user={user} name={name}/></td>
                                    <td>{user.valorant_name}#{user.valorant_tag}</td>
                                    <td><img className="rankbadge" src={user.current_tier_icon} /></td>
                                    <td><img className="rankbadge" src={user.max_tier_icon} /></td>
                                    <td>{user.time_played.hours_played}h {user.time_played.minutes_played}m</td>
                                </tr>
                        })}
                    </tbody>
                </Table>   
            </div>
        )
    }
    
}

export default UserPage